import Header from "components/Header";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import MainTitle from "components/MainTitle";
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";

const HelpRequest = () => {
  const { t, i18n } = useTranslation();
  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );
  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate ****************************/}
        <QuickDonate />

        {/* quick donate popup  *********************/}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  ********************/}
        <MainTitle title={t("Helping Cases")} />

        {/* the content  ****************************/}
        <section className="my-[100px]">
          <div className="mainContainer w-full px-[40px] lg:px-0 flex flex-col gap-[20px]">
            <p
              className={`font-${
                i18n.language === "en"
                  ? "Poppins lg:text-left"
                  : "Almarai lg:text-right"
              } font-[700] text-[28px] lg:text-[32px] text-second_color text-center `}
            >
              {t("Providing assistance electronically")}
            </p>

            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[18px] text-second_color text-center `}
              >
                {t("Conditions for accepting the request:")}
              </p>

              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "The applicant for assistance must meet the following terms & conditions:"
                )}
              </p>

              <ul
                className={`${
                  i18n.language === "en"
                    ? "flex flex-col gap-2 list-disc pl-[20px]"
                    : "flex flex-col gap-2 list-disc pr-[20px]"
                }`}
              >
                {/* <li
                  className={`font-${
                    i18n.language === "en"
                      ? "Poppins lg:text-left"
                      : "Almarai lg:text-right"
                  } font-[400] text-[16px] text-[#444444] text-center`}
                >
                  {t(
                    "I, the undersigned, acknowledge that all the data provided above and the attached documents are correct, and I undertake full responsibility if they are found to be incorrect. If proven otherwise, the committee has the right to reject the application."
                  )}
                </li> */}

                <li
                  className={`font-${
                    i18n.language === "en"
                      ? "Poppins lg:text-left"
                      : "Almarai lg:text-right"
                  } font-[400] text-[16px] text-[#444444] text-center`}
                >
                  {t(
                    "Only applications that meet the institution’s registration requirements will be accepted."
                  )}
                </li>

                <li
                  className={`font-${
                    i18n.language === "en"
                      ? "Poppins lg:text-left"
                      : "Almarai lg:text-right"
                  } font-[400] text-[16px] text-[#444444] text-center`}
                >
                  {t(
                    "Applications for assistance cannot be submitted until one year has passed since the last financial aid was received, or six months for medical assistance."
                  )}
                </li>

                <li
                  className={`font-${
                    i18n.language === "en"
                      ? "Poppins lg:text-left"
                      : "Almarai lg:text-right"
                  } font-[400] text-[16px] text-[#444444] text-center`}
                >
                  {t(
                    "The applicant must have a valid ID to apply for assistance."
                  )}
                </li>

                <li
                  className={`font-${
                    i18n.language === "en"
                      ? "Poppins lg:text-left"
                      : "Almarai lg:text-right"
                  } font-[400] text-[16px] text-[#444444] text-center`}
                >
                  {t(
                    "Registration is open only to residents of Ajman Emirate."
                  )}
                </li>

                <li
                  className={`font-${
                    i18n.language === "en"
                      ? "Poppins lg:text-left"
                      : "Almarai lg:text-right"
                  } font-[400] text-[16px] text-[#444444] text-center`}
                >
                  {t(
                    "Received documents will not be returned, even in the case of rejection."
                  )}
                </li>

                <li
                  className={`font-${
                    i18n.language === "en"
                      ? "Poppins lg:text-left"
                      : "Almarai lg:text-right"
                  } font-[400] text-[16px] text-[#444444] text-center`}
                >
                  {t(
                    "The institution has the right to use all methods of investigation and verification of the case."
                  )}
                </li>
              </ul>
            </div>

            <div className="w-full flex flex-col lg:flex-row items-center justify-center gap-4">
              <a
                href="https://aletihadcharity.ae/"
                className="bg-first_color text-white text-[16px] font-[500] h-[48px] w-[300px] rounded-lg flex items-center justify-center hover:bg-first_color/85 duration-150"
                target="_blank"
                rel="noreferrer"
              >
                {t("New Request")}
              </a>
              <a
                href="https://aletihadcharity.ae/"
                className="bg-first_color text-white text-[16px] font-[500] h-[48px] w-[300px] rounded-lg flex items-center justify-center hover:bg-first_color/85 duration-150"
                target="_blank"
                rel="noreferrer"
              >
                {t("Follow Up Request")}
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default HelpRequest;
